<template>
  <div>
    <template v-if="registerTemplateName_SAVE.includes(`C${datamodel.type.replace(/-/g, '')}`)">
      <component
          v-if="datamodel.value && datamodel.visible"
          :is="`C${datamodel.type.replace(/-/g, '')}`"
          :datamodel="datamodel"
          ref="childComponents"
      ></component>
      <div v-else></div>
    </template>
    <div v-else v-for="(item,index) in datamodel.value" :key="item.type+index">
      <template v-if="registerTemplateName_SAVE.includes(`C${item.type.replace(/-/g, '')}`)">
        <component
            v-if="item.value && item.visible"
            :is="`C${item.type.replace(/-/g, '')}`"
            :datamodel="item"
            ref="childComponents"
        ></component>
        <div v-else></div>  
      </template>
        <C00000000000000000000000000000000 v-else
        :datamodel="item"
        ref="childComponents">
        </C00000000000000000000000000000000>
    </div>
  </div>
</template>

<script>
export default {
  uuid: "00000000-0000-0000-0000-000000000000",
  components: {

  },
  props: [
    "datamodel",
    'inList',
    'imgWidth'],
  data() {
    return {
      itemdata: "",
      callBackJson: {}
    };
  },
  computed: {
    hostKey() {
      return this.fatherContent.key || ""
    }
  },
  watch: {},
  methods: {
  },
  created() {},
  mounted() {
  }
};
</script>
<style lang='scss' scoped>
</style>